import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { open, close } from '../../../helpers/index';

import Facet from './Facet';

const FacetList = ({
  subTitle,
  facets,
  selectedFacets,
  onFiltersChange,
  onResetFilters,
  resetBtnLabel,
  loading,
  featuredLinks
}) => {
  const breakpoint = window.matchMedia('(max-width: 1280px)');
  const filterLists = useRef(null);
  const [displayFilters, setDisplayFilters] = useState(!breakpoint.matches);

  useEffect(() => {
    const listener = () => {
      if (breakpoint.matches) {
        setDisplayFilters(false);
      } else {
        setDisplayFilters(true);
      }
    };

    breakpoint.addListener(listener);
    return () => breakpoint.removeListener(listener);
  }, []);

  useEffect(() => {
    if (displayFilters) {
      open({ element: filterLists.current });
    } else {
      close({ element: filterLists.current });
    }
  }, [displayFilters]);

  const updateHeight = () => {
    filterLists.current.style.height = 'auto';
  };

  const onCleanFilters = () => {
    onResetFilters();
  };

  return (
    <div className="search-results__facets-container">
      {loading && <div className="loading"></div>}
      {facets && (
        <div
          className="facet-listing__button"
          onClick={() => setDisplayFilters(!displayFilters)}
        >
          <a className="btn btn--outline facet-listing__filter">
            {displayFilters ? 'Hide Filter -' : 'Show Filter +'}
          </a>
        </div>
      )}
      <div
        className={
          displayFilters
            ? 'search-results__list-categories search-results__facet-list-categories--expanded'
            : 'search-results__list-categories'
        }
        ref={filterLists}
      >
        {!!facets &&
          facets.map((facet, i) => {
            return (
              <Facet
                key={i}
                facet={facet}
                selected={selectedFacets[facet.keyword] || []}
                onFilterChange={onFiltersChange}
                onListDisplay={updateHeight}
              />
            );
          })}
      </div>
    </div>
  );
};

FacetList.propTypes = {
  facets: PropTypes.array,
  subTitle: PropTypes.string,
  resetBtnLabel: PropTypes.string
};

export default FacetList;
